import React from 'react';
import Timeout from 'await-timeout';
import { getUserData } from './API';
import { getWordEndingError } from './NLP';
import { listen } from './Listen';
import { containsNonAlpha } from './util';
import { findFilenames } from './API';

//Intervention Components
import WordInterventionModal from '../components/WordInterventionModal';
import WordInfoInterventionModal from '../components/WordInfoInterventionModal';
import QuizIntervention from '../components/Interventions/QuizIntervention';
import LipSync from '../components/Interventions/LipSync';
import StudentVideo from '../components/Student/StudentVideo';
import SightWord from '../components/Interventions/SightWord';
import PhonemeGiveWord from '../components/Interventions/PhonemeGiveWord';
import {
  Riddle,
  Morpheme,
  Name,
  Cognate,
  VocabularyWithPicture,
  PredictionQuestion,
  LetterFlies,
  SayASound,
  SoundSeeker,
  SoundOut,
  ElkoninBox,
  UpAndDown,
  WordDisplay,
  ChangeOnePart,
  GiveAndTake,
  Rhyming,
  RhymingQuiz,
  SayOneSound,
  WordInvestigator,
  WordScramble,
  GSF,
  SyllableBlendClick,
  SyllableDecoding,
  SyllableSegmentation,
  HFWDotGrid,
  PhonemeSyllableWord
} from 'amira-intervention-library';

//Images
import pronounce_icon from "../images/intervention_icons/pronounce.svg";
import spell_icon from "../images/intervention_icons/spell.svg";
import rhyme_icon from "../images/intervention_icons/rhyme.svg";
import lip_sync_icon from "../images/intervention_icons/lip_sync.svg";
import {COPY_STRINGS} from '../constants/translatedCopy';


//Intervention Selection
import {
  wordDidIntervene,
  getRhyme,
  speakInterventionLeadIn,
} from './interventionSelection.js';

import {
  interventionType,
} from '../constants/interventionSelectionConstants';
import { wordEndingErrorType } from '../constants/constants';
import ListeningStatus from '../components/Global/ListeningStatus';

//TODO: remove these when listening is wired up in say word intervention
import store from '../store';
import speechCreators from "Components/Reader/Speech/state/creators";
import { shouldSoundOutPhonemes } from './InterventionUtils';
import {getRandomDistractorImages, getWordMetadataList, getSubMetadata} from "./WordMetadataService";
import { isiPad } from './environment.js';
import { logSessionInfo } from './logger.js';
import FTUEService from './FTUEService.js';
import { getCopyByGradeband } from "./ThemingService";

let interventionHistory = [];
let comprehensionQuizCount = 0;

export function resetComprehensionQuizCount(){
  comprehensionQuizCount = 0;
}

// Used for intervention that don't actually listen, and need to manage the mic on their own
export function startFakeListen() {
  store.dispatch(speechCreators.setIsListening(true));
}

export function stopFakeListen() {
  store.dispatch(speechCreators.setIsListening(false));
}

function getWordInterventionModal(word, instructions, { icon, useWordIcon }, rightContent=null, showListeningStatus=true){
  return(
    <WordInterventionModal
      word={word}
      instructions={instructions}
      icon={icon}
      useWordIcon={useWordIcon}
      rightContent={rightContent}
      showListeningStatus={showListeningStatus}
    />
  );
}

// This will format the data for all the Intervention Handlers
function formatResults(modal, message, closeButton=false){
  return {
    modal,
    message,
    closeButton,
  };
}

export function preflightIntervention(interventionWord,intervention){
  // Using multiple returns to keep this nice and simple

  //comprehension always passes preflight because it's selected when question content exists, regardless of phrase errors
  if(intervention.type === interventionType.comprehension) return true;

  if(!interventionWord) return false;
  if(!intervention) return false
  if((intervention.type === interventionType.tense) && (!intervention.closeError)) return false;
  if(!intervention.metadata) return false;

  return true;
}

export function getIntervention({speech, inWord, callback, endOfPhrase, chosenIntervention, currentWordIndex, handleMessage, skipWord, phraseMeta, mostRecentScores, fromUNKFallback = false, story, isSpanishPilot}){
  let interventionWord = inWord;

  let interventionVersion = null;
  if(chosenIntervention.type){
    interventionVersion = parseInt(chosenIntervention.type.charAt(chosenIntervention.type.length - 1));
    if(Number.isNaN(interventionVersion)) interventionVersion = null;
  }

  if(chosenIntervention.metadata && (chosenIntervention.metadata.NAME_FLAG || chosenIntervention.metadata.NAME_MEANING)) {
    interventionWord = interventionWord.charAt(0).toUpperCase() + interventionWord.slice(1).toLowerCase();
  } else {
    interventionWord = interventionWord.toLowerCase();
  }


  switch (chosenIntervention.type) {
    case interventionType.none:
      skipWord && skipWord(false, false, false, fromUNKFallback);
      break;
    case interventionType.skip:
      skipWord && skipWord(false, false, false, fromUNKFallback);
      break;
    case interventionType.giveword:
      // Default to speaking the word (true) unless explicitly disabled (false).
      // This ensures null/undefined values default to true, only explicit false disables speaking.
      let shouldSayWord = (getUserData().sorConfig.enableGiveWord !== false);
      if(!endOfPhrase){
        skipWord && skipWord(shouldSayWord, false, false, fromUNKFallback);
      }else{
        skipWord && skipWord(false, false, false, fromUNKFallback);
      }
      break;
    case interventionType.phonemeGiveWord:
      handlePhonemeGiveWord(speech, interventionWord, chosenIntervention, handleMessage, endOfPhrase, callback);
      break;
    case interventionType.tense:
      handleSayWord(speech, interventionWord, callback,endOfPhrase,chosenIntervention.closeError);
      break;
    case interventionType.phonemeLipsync:
    case interventionType.lipsync:
      handleLipSync(speech, interventionWord,callback,endOfPhrase,chosenIntervention.metadata,chosenIntervention.type);
      break;
    case interventionType.spellout:
      handleSpellOutAfterStudent(speech, interventionWord, callback, endOfPhrase, chosenIntervention.metadata);
      break;
    case interventionType.spelloutBefore:
      handleSpellOutBeforeStudent(speech, interventionWord, callback, endOfPhrase, chosenIntervention.metadata);
      break;
    case interventionType.rhyme:
      handleRhymingWord(speech, interventionWord, callback,endOfPhrase,chosenIntervention.metadata);
      break;
    case interventionType.funfact:
      handleFunFact(speech, interventionWord, callback, endOfPhrase,chosenIntervention.metadata);
      break;
    case interventionType.simpledefinition:
      handleSimpleDefinition(speech, interventionWord, callback, endOfPhrase,chosenIntervention.metadata);
      break;
    case interventionType.sayit:
      handleSayWord(speech, interventionWord, callback,endOfPhrase,chosenIntervention.metadata);
      break;
    case interventionType.sight:
      handleSightWord(speech, interventionWord, handleMessage, endOfPhrase, callback);
      break;
    case interventionType.comprehension:
      handleComprehension(speech, interventionWord, handleMessage, endOfPhrase, phraseMeta, callback, story, isSpanishPilot);
      break;
    case interventionType.riddle:
      handleRiddle(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback);
      break;
    case interventionType.morpheme:
      handleMorpheme(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback);
      break;
    case interventionType.cognate:
      handleCognate(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback);
      break;
    case interventionType.vocabularyWithPictures:
      handleVocabularyWithPicture(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback);
      break;
    case interventionType.prediction:
      handlePrediction(speech, interventionWord, chosenIntervention.metadata, phraseMeta, handleMessage, endOfPhrase, callback);
      break;
    case interventionType.letterFlies:
      handleLetterFlies(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback, interventionVersion);
      break;
    case interventionType.sayASound:
      handleSayASound(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback, interventionVersion);
      break;
    case interventionType.soundSeeker:
      handleSoundSeeker(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback, interventionVersion, mostRecentScores);
      break;
    case interventionType.name1:
    case interventionType.name2:
      handleName(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback, interventionVersion);
      break;
    case interventionType.soundout1:
    case interventionType.soundout2:
    case interventionType.soundout3:
      handleSoundOut(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback, interventionVersion);
      break;
    case interventionType.elkoninBox0:
    case interventionType.elkoninBox1:
    case interventionType.elkoninBox2:
    case interventionType.elkoninBox3:
    case interventionType.elkoninBox4:
      handleElkoninBox(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback, interventionVersion);
      break;
    case interventionType.upAndDown1:
    case interventionType.upAndDown2:
    case interventionType.upAndDown3:
      handleUpAndDown(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback, interventionVersion);
      break;
    case interventionType.changeOnePart1:
      handleChangeOnePart(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback, interventionVersion, mostRecentScores);
      break;
    case interventionType.giveAndTake1:
      handleGiveAndTake(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback, interventionVersion, mostRecentScores);
      break;
    case interventionType.rhyming1:
      handleRhyming(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback, interventionVersion);
      break;
    case interventionType.rhymingQuiz1:
      handleRhymingQuiz(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback, interventionVersion);
      break;
    case interventionType.sayOneSound1:
      handleSayOneSound(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback, interventionVersion);
      break;
    case interventionType.wordInvestigator1:
    case interventionType.wordInvestigator2:
      handleWordInvestigator(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback, interventionVersion);
      break;
    case interventionType.wordScramble1:
      handleWordScramble(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback, interventionVersion);
      break;
    case interventionType.wordDisplay:
      handleWordDisplay(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback, interventionVersion);
      break;
    case interventionType.GSF:
      handleGSF(chosenIntervention.gsfWordBank, speech, interventionWord, handleMessage, endOfPhrase, phraseMeta, callback);
      break;
    case interventionType.msylSegment:
      handleMsylSegment(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback);
      break;
    case interventionType.syllableBlendClick:
      handleSyllableBlendClick(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback);
      break;
    case interventionType.syllableDecoding:
      handleSyllableDecoding(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback);
      break;
    case interventionType.phonemeSyllableWord:
      handlePhonemeSyllableWord(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback);
      break;
    case interventionType.hfwDotGrid:
      handleHFWDotGrid(speech, interventionWord, chosenIntervention.metadata, handleMessage, endOfPhrase, callback);
      break;
    default:
      // TODO: refactor so that this 'default' is unnecessary, and so that
      // interventionHistory is accurate
      console.log('INTERVENTION MANAGER INVALID INTERVENTION: ', chosenIntervention);
      if (chosenIntervention.fallback) {
        // If a fallback is provided, use it
        const newChosenIntervention = {
          ...chosenIntervention,
          type: chosenIntervention.fallback,
          fallback: null,
        }
        getIntervention({speech, inWord, callback, endOfPhrase, chosenIntervention: newChosenIntervention, currentWordIndex, handleMessage, skipWord, phraseMeta, mostRecentScores, fromUNKFallback, story, isSpanishPilot});
        return;
      } else {
        // If no fallback provided, restort to giveWord as final failsafe
        chosenIntervention.type = interventionType.giveword;
        // Default to speaking the word (true) unless explicitly disabled (false).
        // This ensures null/undefined values default to true, only explicit false disables speaking.
        let shouldSayWord = (getUserData().sorConfig.enableGiveWord !== false);
        if(!endOfPhrase){
          skipWord && skipWord(shouldSayWord, false, false, fromUNKFallback);
        }else{
          skipWord && skipWord(false, false, false, fromUNKFallback);
        }
      }
      break;
  }
  
  // Only track intervention if NOT from UNK fallback
  if (!fromUNKFallback) {
    interventionHistory.push(chosenIntervention.type);
    wordDidIntervene({word: inWord,type: chosenIntervention.type},endOfPhrase);
  }
}


// returns an Array of Interventions with their title, icon and handler functions
export function getMenuInterventions(){
  return [
    {
      title: 'Pronunciation',
      icon: pronounce_icon,
      triggerIntervention: handleSayWord,
    },
    {
      title: 'Rhyming Word',
      icon: rhyme_icon,
      triggerIntervention: handleRhymingWord,
    },
    {
      title: 'Spell',
      icon: spell_icon,
      triggerIntervention: handleSpellOut,
    },
    {
      title: 'Lip Sync',
      icon: lip_sync_icon,
      //not yet implemented
    },
  ];
}

/******************** INTERVENTION HANDLERS ********************/
function handlePhonemeGiveWord(speech, inWord, chosenIntervention, handleMessage, endOfPhrase, callback){
  callback(
    {modal:
      <PhonemeGiveWord
        speech={speech}
        inWord={inWord}
        handleMessage={handleMessage}
        endOfPhrase={endOfPhrase}
        chosenIntervention={chosenIntervention}
      />
    }
  );
}

function handleRhymingWord(speech, word, callback,endOfPhrase=false,metadata){
  /*poll(getRhymingWord, word, 30000, 6000)
    .then(resp => {
      if(!resp[0])
      {
        console.log("NO RHYME!");
        handleSayWord(word,callback,endOfPhrase);
        return;
      }*/
      const rhyme = metadata.RHYME;//getRhyme(word);//resp[0].word;

      let speakRhymeIntro = (onEnd) => {
        let forceEnqueue = false;
        if(endOfPhrase){
          speakInterventionLeadIn(speech, interventionType.rhyme,word);
          forceEnqueue = true;
        }
        if(getUserData().bilingualMode){
          speech.speak({textToSpeak: COPY_STRINGS.intervention_strings.rhymes_with + ":"}, undefined, undefined, forceEnqueue);
          speech.speak({textToSpeak: "<prosody rate=\"slow\"> " + rhyme + " </prosody>", skipTranslation: true, onEnd: onEnd}, undefined, undefined, true);
        } else {
          let textToSpeak = `${COPY_STRINGS.intervention_strings.rhymes_with} "${rhyme}".`;
          speech.speak({ textToSpeak: textToSpeak, onEnd: onEnd});
        }
      }

      const rightContent = (
        <div className="right centerContent">
          <div className="instructions">
            <span className="keyWord">{word}</span>
            <span> {COPY_STRINGS.intervention_strings.rhymes} {COPY_STRINGS.intervention_strings.with} {rhyme}</span>
            <div className="listeningStatusWrapper"><ListeningStatus/></div>
          </div>
        </div>
      );
      const image = {
        icon: rhyme_icon,
        useWordIcon: true,
      };
      const modal = getWordInterventionModal("", null, image, rightContent);
      const message = {
        speakFunction: speakRhymeIntro,
        callback: getWordResponse.bind(null, {
          speech: speech,
          targetWord: word,
          callback: callback,
          interventionType: interventionType.rhyme,
          endOfPhrase: endOfPhrase,
        }),
      };
      const data = formatResults(modal, message);
      callback(data);
    //})
  //.catch(err => console.log("ERROR IN HANDLE RHYMING: ", err));
}

//First ask the student to try, then spell out the word
function handleSpellOutAfterStudent(speech, word, callback, endOfPhrase=false, metadata=null){
  const onListenDone = (listener) => {
    const onEnd = moveOnWithoutSpeaking.bind(null, callback, endOfPhrase);
    if(listener.matches && (listener.matches.targetMatches || listener.matches.moveOn)){
      onEnd();
    } else {
      if(getUserData().bilingualMode){
        speech.speak({textToSpeak: "<prosody rate=\"slow\"><say-as interpret-as=\"spell-out\">" + word + "</say-as></prosody>", passThroughSpeechTags: true, skipTranslation: true});
        speech.speak({textToSpeak: COPY_STRINGS.intervention_strings.is_pronounced, passThroughSpeechTags: true});
        speech.speak({textToSpeak: word, passThroughSpeechTags: true, skipTranslation: true, onEnd: onEnd}, undefined, undefined, true);
      } else {
        let textToSpeak = "<prosody rate=\"slow\"><say-as interpret-as=\"spell-out\">" +
          `"${word}"` + "</say-as></prosody>" + ", " + COPY_STRINGS.intervention_strings.is_pronounced + ": " + `"${word}"`;

        speech.speak({
          textToSpeak,
          passThroughSpeechTags: true,
          onEnd: onEnd,
        });
      }
    }
  };

  //If we have the number of Letters and the number of Phonemes
  //display this instead of the default icon
  let filenames = [];
  if(word.length && metadata && metadata.PHON){
    filenames = findFilenames(metadata.PHON);
  }

  const instructions = (<div>{COPY_STRINGS.intervention_strings.letsWorkOn}</div>);
  let modal;
  if(filenames.length){
    modal = (
      <WordInfoInterventionModal
        word={word}
        instructions={instructions}
        numberOfSounds={filenames.length}
      />
    );
  }else {
    const image = {
      icon: spell_icon,
      useWordIcon: true,
    };
    modal = getWordInterventionModal(word, instructions, image);
  }

  const message = {
    listen: getWordResponse.bind(null, {
      speech: speech,
      targetWord: word,
      callback: callback,
      endOfPhrase: endOfPhrase,
      onListenDone: onListenDone,
      interventionType: interventionType.spellout,
      closeText: COPY_STRINGS.intervention_strings.spellOutLeadIn,
    }),
    callback: moveOnWithoutSpeaking.bind(null, callback, endOfPhrase),
  };
  const data = formatResults(modal, message);
  callback(data);
}

//first spell out the word, then ask the student to try
function handleSpellOutBeforeStudent(speech, word, callback, endOfPhrase=false, metadata=null){
  const instructions = (<div>{COPY_STRINGS.intervention_strings.letsWorkOn}</div>);

  let speakSpellOut = (onEnd) => {
    speakInterventionLeadIn(speech, interventionType.spelloutBefore, word, null);
    if(getUserData().bilingualMode){
      speech.speak({textToSpeak: "<prosody rate=\"slow\"><say-as interpret-as=\"spell-out\">" + word + "</say-as></prosody>, ", passThroughSpeechTags: true, skipTranslation: true});
      speech.speak({textToSpeak: COPY_STRINGS.intervention_strings.is_pronounced});
      speech.speak({textToSpeak: word, passThroughSpeechTags: true, skipTranslation: true, onEnd: onEnd}, undefined, undefined, true);
    } else {
      let textToSpeak = "<prosody rate=\"slow\"><say-as interpret-as=\"spell-out\">" +
        `"${word}"` + "</say-as></prosody>, " + COPY_STRINGS.intervention_strings.is_pronounced + ": " + `"${word}"`;

      speech.speak({
        textToSpeak,
        passThroughSpeechTags: true,
        onEnd: onEnd,
      });
    }
  }

  //If we have the number of Letters and the number of Phonemes
  //display this instead of the default icon
  let filenames = [];
  if(word.length && metadata && metadata.PHON){
    filenames = findFilenames(metadata.PHON);
  }

  let modal;
  if(filenames.length){
    modal = (
      <WordInfoInterventionModal
        word={word}
        instructions={instructions}
        numberOfSounds={filenames.length}
      />
    );
  }else {
    const image = {
      icon: spell_icon,
      useWordIcon: true,
    };
    modal = getWordInterventionModal(word, instructions, image);
  }

  const message = {
    speakFunction: speakSpellOut,
    callback: getWordResponse.bind(null, {
      speech: speech,
      targetWord: word,
      callback: callback,
      interventionType: interventionType.spelloutBefore,
      endOfPhrase: endOfPhrase,
    }),
  };
  const data = formatResults(modal, message);
  callback(data);
}

function getMistakeString(utteredWord, desiredWord){
  const { type, ending } = getWordEndingError(utteredWord, desiredWord);
  let endingWithPauses = ending ? ending.split('').join(' ') : ending;

  switch(type){
    case wordEndingErrorType.ADDED:
      //TODO: AE-3869 split this string
      return COPY_STRINGS.intervention_strings.mistake_added(endingWithPauses);
    case wordEndingErrorType.DROPPED:
      //TODO: AE-3869 split this string
      return COPY_STRINGS.intervention_strings.mistake_dropped(endingWithPauses);
    case wordEndingErrorType.MIX:
      //TODO: AE-3869 split this string
      return COPY_STRINGS.intervention_strings.mistake_mix_up_ending(endingWithPauses)
    default:
      return COPY_STRINGS.intervention_strings.make_this_mistake;
  }
}

//If this is a tense intervention, closeError will contain data about the desired and uttered words.
//Otherwise it will contain the word metadata.
function handleSayWord(speech, word, callback,endOfPhrase=false,closeError=null){
  let instructions = (<div>{COPY_STRINGS.intervention_strings.sound_out_capitalized}</div>);
  let closeText = "";
  let runDoRequestForWord = true;
  let interventionWordLength = word.replace(/'/g, '').length;
  const isTenseIntervention = (closeError && closeError.utteredWord && closeError.desiredWord);
  const wordSpelled = "<prosody rate=\"slow\"><say-as interpret-as=\"spell-out\">" + word + "</say-as></prosody>";

  //hacking in the listening status until listener is wired up
  /**
   * This is here because we don't actually listen and match the student's speech to what they're trying to say.
   * The primary reason is that we're asking the student to sound out the word and our ASRs/Error detection won't
   * accurately capture/score the student's speech when they're sounding out phoneme-by-phoneme.
   */
  //TODO: implement listener and remove the redux store import and this code
  const fakeListenTimer = new Timeout();
  const FAKE_LISTEN_TIMEOUT = 3500;
  const fakeListen = (onTimeout) => {
    store.dispatch(speechCreators.setIsListening(true));
    fakeListenTimer.set(FAKE_LISTEN_TIMEOUT).then(() => {
      fakeListenTimer.clear();
      store.dispatch(speechCreators.setIsListening(false));
      onTimeout();
    });
  };

  if(isTenseIntervention){
    //Changing the instructions for this intervention
    instructions = (<div>{COPY_STRINGS.intervention_strings.pay_attention_to_the_word_ending}</div>);
    closeText = COPY_STRINGS.intervention_strings.now_you_say_word;
  }else {
    runDoRequestForWord = false;
  }

  let speakSayWord = (onEnd) => {
    let filenames;
    if(closeError && (!closeError.utteredWord || !closeError.desiredWord) && closeError.PHON && !containsNonAlpha(word)) {
      //If we have the phonemes then we get the audio files for each one
      filenames = findFilenames(closeError.PHON);
    }

    if(isTenseIntervention){
      /**** TENSE INTERVENTION ****/
      //TODO: Might be a good idea to move this out into its own intervention
      const { utteredWord, desiredWord } = closeError;
      if(getUserData().bilingualMode){
        speech.speak({textToSpeak: COPY_STRINGS.intervention_strings.you_said});
        speech.speak({textToSpeak: utteredWord, skipTranslation: true}, undefined, undefined, true);
        speech.speak({textToSpeak: COPY_STRINGS.intervention_strings.instead_of});
        speech.speak({textToSpeak: desiredWord, skipTranslation: true});
        speech.speak({textToSpeak: COPY_STRINGS.intervention_strings.the_word_is + ":"});
        speech.speak({textToSpeak: "<prosody rate=\"slow\"> " + word + " </prosody>", skipTranslation: true, onEnd: onEnd});
      } else {
        //TODO: AE-3869 fork mistake strings and add this behavior to bilingual fork above
        let textToSpeak =
          COPY_STRINGS.intervention_strings.you_said + " "
          + utteredWord + " "
          + COPY_STRINGS.intervention_strings.instead_of + " "
          + desiredWord
          + ". " + COPY_STRINGS.intervention_strings.be_careful_not_to + getMistakeString(utteredWord, desiredWord);
        speech.speak({textToSpeak: textToSpeak, onEnd: onEnd, passThroughSpeechTags: true});
      }
    }else{
      //If we got here, the object passed into the closeError field is word metadata. Rename it to avoid confusion
      let wordMetadata = closeError;
      let forceEnqueue = false;

      let numberOfSounds = (wordMetadata && wordMetadata.NSYL) ? wordMetadata.NSYL : 1; //TODO: drive this back to selection rules (shouldn't do this intervention with no NSYL data)

      if(endOfPhrase){
        speakInterventionLeadIn(speech, interventionType.sayit,word);
        forceEnqueue = true;
      }

      //If we have audio we handle the onEnd case in the following recursive function
      /**
       * We found that sounding out every phoneme for words with > 5 phonemes hurts the user
       * experience on the student, so we will not sound out every phoneme in this case.
       */
      if(filenames && shouldSoundOutPhonemes(wordMetadata)) {
        let intro = COPY_STRINGS.intervention_strings.word_has_many_letters_and_many_sounds(interventionWordLength, filenames.length || 0)
                    + "<break time=\"0.5s\"/>"
                    + COPY_STRINGS.intervention_strings.try_to_sound_it_out;

        // function to speak the phonemes of the word
        let onEndWithPhonemes = (inFilenames, onEnd) => {
          if(inFilenames.length == 0){//If we've played all the phonemes then add a pause and say the close speech
            if(getUserData().bilingualMode){
              speech.speak({
                textToSpeak: "<break time=\"0.5s\" />" + COPY_STRINGS.intervention_strings.makes,
                passThroughSpeechTags: true,
              });
              speech.speak({
                textToSpeak: word,
                onEnd: onEnd,
                passThroughSpeechTags: true,
                skipTranslation: true,
              }, undefined, undefined, true);
            } else {
              speech.speak({
                textToSpeak: "<break time=\"0.5s\" />" + COPY_STRINGS.intervention_strings.makes + ": " + `"${word}".`,
                onEnd: onEnd,
                passThroughSpeechTags: true
              });
            }
            return;
          }else{
            console.log('Playing phoneme for intervention word:', JSON.stringify({
              word: word,
              url: inFilenames?.length ? inFilenames[0] : undefined,
            }));
            //create the sound, and recursively play the rest of the phonemes when the current one is done.
            //IOW, call this method again in the onfinish event of the current phoneme.
            speech.speakAudioFile({
              url: inFilenames[0],
              onfinish: onEndWithPhonemes.bind(null,inFilenames.slice(1),onEnd),
            });//Always play the first phoneme in the Array
          }
        }

        const onFakeListenDone = (onEnd) => {
          speech.speak({
            textToSpeak: getCopyByGradeband(COPY_STRINGS.intervention_strings, 'ok_im_going_to_sound_out_this_word_for_you'),
            passThroughSpeechTags: true,
            onEnd: onEnd,
          });
        };

        speech.speak({
          textToSpeak: intro,
          passThroughSpeechTags: true,
          onEnd: fakeListen.bind(this, onFakeListenDone.bind(this, onEndWithPhonemes.bind(window, filenames, onEnd))),
        });
      }else {//If we don't have the audio just spell the word
        const textToSpeak = COPY_STRINGS.intervention_strings.word_has_many_letters_and_many_syllables(interventionWordLength, numberOfSounds)
          + "<break time=\"0.5s\"/>"
          + COPY_STRINGS.intervention_strings.try_to_sound_it_out;

        if(getUserData().bilingualMode){
          speech.speak({
            textToSpeak: textToSpeak,
            passThroughSpeechTags: true,
            onEnd: fakeListen.bind(this, () => {
              speech.speak({textToSpeak: COPY_STRINGS.intervention_strings.ok, passThroughSpeechTags: true});
              speech.speak({textToSpeak: wordSpelled, skipTranslation: true, passThroughSpeechTags: true}, undefined, undefined, true);
              speech.speak({textToSpeak: COPY_STRINGS.intervention_strings.makes});
              speech.speak({textToSpeak: word, skipTranslation: true, onEnd: onEnd});
            }),
          });
        } else {
          speech.speak({
            textToSpeak: textToSpeak,
            passThroughSpeechTags: true,
            onEnd: fakeListen.bind(this, () => {
              speech.speak({
                textToSpeak: COPY_STRINGS.intervention_strings.ok + " " + wordSpelled + " " + COPY_STRINGS.intervention_strings.makes + ": " + `"${word}".`,
                passThroughSpeechTags: true,
                onEnd: onEnd,
              });
            }),
          });
        }
      }
    }
  }

  // This is complicated:
  // - If we are at the end of a phrase AND the request for word is set, then we ask the student for a word
  // - If we are the end of a phrase AND the request for word is clear, then we move on without speaking
  // - If we are in the middle of a phrase, we never ask the student for the word
  let wordToDisplay;
  //AE-3805 - Only display the graphemic break down if it cleans up to equal the intervention word.  This ensures
  //we display contractions correctly when the word is "he's" but the graphemic breakdown is "h/e/s" (doesn't contain the apostrophe).
  if(closeError && closeError.GRAPHEMIC_BREAKDOWN && closeError.GRAPHEMIC_BREAKDOWN.split('/').join('') === word){
    wordToDisplay = closeError.GRAPHEMIC_BREAKDOWN.split('/').join(' ');
  }else {
    wordToDisplay = word.split('').join(' ');
  }

  let icon = pronounce_icon;
  if(isTenseIntervention){
    //The instructions are too long for the Tense intervention so we need to remove the icon
    icon = null;
  }

  const image = {
    icon,
    useWordIcon: true,
  };

  const modal = getWordInterventionModal(wordToDisplay, instructions, image, null, true);
  const doRequestForWord = runDoRequestForWord ? getWordResponse.bind(null, {
    speech: speech,
    targetWord: word,
    callback: callback,
    interventionType: isTenseIntervention ? interventionType.tense : interventionType.sayit,
    closeText: closeText,
    endOfPhrase: endOfPhrase,
  }) : moveOnWithoutSpeaking.bind(null,callback, endOfPhrase);

  const message = {
    speakFunction: speakSayWord,
    callback: doRequestForWord,
  };
  const data = formatResults(modal, message);
  callback(data);
}

function handleSightWord(speech, word, handleMessage, endOfPhrase, callback){
  callback(
    {modal:
      <SightWord
        speech={speech}
        inWord={word}
        handleMessage={handleMessage}
        endOfPhrase={endOfPhrase}
      />
    }
  );
}

function getNormalizedSelectionHistory(selectionHistory=[]){
  return selectionHistory.map((selection) => {
    const selectedPrefix = 'selected ';
    if(typeof selection === 'string' && selection.indexOf(selectedPrefix) === 0){
      return selection.slice(selectedPrefix.length);
    }
    return selection;
  });
}

/**
 * Builds and logs comprehension quiz metrics via logSessionInfo.
 * Assigns a 0-based quizIndex per activity and increments the counter.
 * Called from both mid-story comprehension interventions and the end-of-story quiz path.
 *
 * @param {Array} results - Per-question result objects from Quiz component (selectionHistory, isCorrect, etc.)
 * @param {Array} questions - Question definitions from story/phrase metadata (text, correct, etc.)
 */
export function logComprehensionQuizMetrics(results, questions){
  const quizIndex = comprehensionQuizCount;
  comprehensionQuizCount += 1;

  const questionMetrics = (questions || []).map((question, idx) => {
    const result = results && results[idx];
    return {
      question: question ? question.text : null,
      attemptsInOrder: result ? getNormalizedSelectionHistory(result.selectionHistory) : [],
      correctAnswer: question ? question.correct : null,
      isCorrect: result ? result.isCorrect : false,
    };
  });

  logSessionInfo(`comprehension_quiz_${quizIndex}`, {
    quizIndex,
    questions: questionMetrics,
  });
}

function handleQuizSubmit(results, callback, questions){
  logComprehensionQuizMetrics(results, questions);
  moveOnWithoutSpeaking(callback, true); //assumes quiz intervention will always be end of phrase. Change this if that ever stops being true
}

function handleComprehension(speech, word, handleMessage, endOfPhrase, phraseMeta, callback, story, isSpanishPilot){
  if(!(phraseMeta && phraseMeta.questions && phraseMeta.questions.length)){
    moveOnWithoutSpeaking(callback,endOfPhrase);
    return;
  }
  callback(
    {modal:
      <QuizIntervention
        speech={speech}
        questions={phraseMeta.questions}
        onSubmit={(results) => {handleQuizSubmit(results, callback, phraseMeta.questions)}}
        story={story}
        isSpanishPilot={isSpanishPilot}
      />
    }
  );
}

function handleGSF(gsfWordBank, speech, word, handleMessage, endOfPhrase, phraseMeta, callback){
  if (!gsfWordBank) {
    moveOnWithoutSpeaking(callback, endOfPhrase);
    return;
  }

  callback(
    {
      modal:
        <GSF
          speech={speech}
          wordBankMetadata={gsfWordBank}
          endOfPhrase={endOfPhrase}
          handleMessage={handleMessage}
          ftue={checkFtue([interventionType.GSF])}
          isiPad={isiPad()}
          logSessionInfo={logSessionInfo}
        />,
      delayedCloseButtonTimeoutOverride: 60000, // Show the manual close button after 60 seconds for this intervention instead of default 30s since there is a lot to get through
    }
  );
}

function handleMsylSegment(speech, word, metadata, handleMessage, endOfPhrase, callback){
  if (!metadata || !metadata.SYLLABLE_ENCODING) {
    moveOnWithoutSpeaking(callback, endOfPhrase);
    return;
  }

  callback(
    {
      modal:
        <SyllableSegmentation
          speech={speech}
          word={metadata.SYLLABLE_ENCODING}
          endOfPhrase={endOfPhrase}
          handleMessage={handleMessage}
          ftue={FTUEService.getCompletedFTUEs()} // This object will contain more than just the multisyllable completed FTUEs, but that's okay
          ftueCb={(ftueId) => {
            FTUEService.setFTUEStatus(ftueId, true);
          }}
          logSessionInfo={logSessionInfo}
        />,
      delayedCloseButtonTimeoutOverride: 60000, // Show the manual close button after 60 seconds for this intervention instead of default 30s since there is a lot to get through
    },
  );
}

function handleSyllableBlendClick(speech, word, metadata, handleMessage, endOfPhrase, callback){
  if (!metadata || !metadata.ALPHSYL) {
    moveOnWithoutSpeaking(callback, endOfPhrase);
    return;
  }

  callback(
    {
      modal:
        <SyllableBlendClick
          speech={speech}
          word={metadata.ALPHSYL}
          endOfPhrase={endOfPhrase}
          handleMessage={handleMessage}
          ftue={FTUEService.getCompletedFTUEs()}
          ftueCb={(ftueId) => {
            FTUEService.setFTUEStatus(ftueId, true);
          }}
          logSessionInfo={logSessionInfo}
        />,
    },
  );
}

function handleSyllableDecoding(speech, word, metadata, handleMessage, endOfPhrase, callback){
  if (!metadata || !metadata.ALPHSYL) {
    moveOnWithoutSpeaking(callback, endOfPhrase);
    return;
  }

  callback(
    {
      modal:
        <SyllableDecoding
          speech={speech}
          word={metadata.ALPHSYL}
          endOfPhrase={endOfPhrase}
          handleMessage={handleMessage}
          ftue={FTUEService.getCompletedFTUEs()}
          ftueCb={(ftueId) => {
            FTUEService.setFTUEStatus(ftueId, true);
          }}
          logSessionInfo={logSessionInfo}
        />,
    },
  );
}

// Unlike the syllable-only interventions (which only need ALPHSYL), this one walks the word
// sound-by-sound first, so it gets the real word plus the full metadata (PHON +
// GRAPHEMIC_BREAKDOWN + ALPHSYL); the component validates the grapheme/phoneme alignment.
function handlePhonemeSyllableWord(speech, word, metadata, handleMessage, endOfPhrase, callback){
  if (!metadata || !metadata.ALPHSYL || !metadata.PHON || !metadata.GRAPHEMIC_BREAKDOWN || !word) {
    moveOnWithoutSpeaking(callback, endOfPhrase);
    return;
  }

  callback(
    {
      modal:
        <PhonemeSyllableWord
          speech={speech}
          word={word}
          wordMetadata={metadata}
          endOfPhrase={endOfPhrase}
          handleMessage={handleMessage}
          ftue={FTUEService.getCompletedFTUEs()}
          ftueCb={(ftueId) => {
            FTUEService.setFTUEStatus(ftueId, true);
          }}
          logSessionInfo={logSessionInfo}
        />,
    },
  );
}

function handleHFWDotGrid(speech, word, metadata, handleMessage, endOfPhrase, callback){
  if (!metadata || !metadata.PHON || !word) {
    moveOnWithoutSpeaking(callback, endOfPhrase);
    return;
  }

  callback(
    {
      modal:
        <HFWDotGrid
          speech={speech}
          word={word}
          wordMetadata={metadata}
          endOfPhrase={endOfPhrase}
          handleMessage={handleMessage}
          isFTUE={FTUEService.getCompletedFTUEs().indexOf(interventionType.hfwDotGrid) === -1}
          ftueCb={() => {
            FTUEService.setFTUEStatus(interventionType.hfwDotGrid, true);
          }}
          logSessionInfo={logSessionInfo}
          isiPad={isiPad()}
        />,
      delayedCloseButtonTimeoutOverride: 60000, // Show the manual close button after 60 seconds for this intervention instead of default 30s since there is a lot to get through
    },
  );
}

function handleSimpleDefinition(speech, word, callback, endOfPhrase=false, metadata){

  const title = COPY_STRINGS.intervention_strings.lets_read_the_word + ": ";
  const instructions = (<div>{title}</div>);

  let speakSimpleDefinition = (onEnd) => {
    let forceEnqueue = false;
    if(endOfPhrase){
      speakInterventionLeadIn(speech, interventionType.simpledefinition,word);
      forceEnqueue = true;
    }

    if(getUserData().bilingualMode){
      speech.speak({textToSpeak: word, skipTranslation: true}, undefined, undefined, forceEnqueue);
      speech.speak({textToSpeak: COPY_STRINGS.intervention_strings.means + ","}, undefined, undefined, true);
      speech.speak({textToSpeak: metadata.DEFINITION.default, skipTranslation: true, onEnd: onEnd});
    } else {
      let textToSpeak = `"${word}"` + " " + COPY_STRINGS.intervention_strings.means + ": " + metadata.DEFINITION.default;
      speech.speak({textToSpeak: textToSpeak, onEnd: onEnd});
    }
  }

  const image = {
    icon: metadata.IMG_URL ? metadata.IMG_URL : pronounce_icon,
    useWordIcon: metadata.IMG_URL ? false : true,
  };
  const modal = getWordInterventionModal(word, instructions, image);
  const message = {
    speakFunction: speakSimpleDefinition,
    callback:   getWordResponse.bind(null, {
      speech: speech,
      targetWord: word,
      callback: callback,
      interventionType: interventionType.simpledefinition,
      endOfPhrase: endOfPhrase,
    }),
  };
  const data = formatResults(modal, message);
  callback(data);
}

function handleFunFact(speech, word, callback, endOfPhrase=false, metadata){
  const title = COPY_STRINGS.intervention_strings.fun_fact;
  const instructions = (<div>{title}</div>);

  let speakFunFact = (onEnd) => {
    if(getUserData().bilingualMode){
      speech.speak({textToSpeak: COPY_STRINGS.intervention_strings.heres_a_fact});
      speech.speak({textToSpeak: word + ". " + "<break time=\"0.5s\"/>" + metadata.FUNFACTS_DESCRIPTION, skipTranslation: true, onEnd: onEnd}, undefined, undefined, true);
    } else {
      let textToSpeak = COPY_STRINGS.intervention_strings.heres_a_fact + " " + `"${word}"` + ". " + "<break time=\"0.5s\"/>" + metadata.FUNFACTS_DESCRIPTION;
      speech.speak({textToSpeak: textToSpeak, onEnd: onEnd});
    }
  }
  const image = {
    icon: metadata.FUNFACTS_IMG_URL ? metadata.FUNFACTS_IMG_URL : null,
    useWordIcon: metadata.FUNFACTS_IMG_URL ? false : true,
  };
  const modal = getWordInterventionModal(word, instructions, image);
  const message = {
    speakFunction: speakFunFact,
    callback: getWordResponse.bind(null, {
      speech: speech,
      targetWord: word,
      callback: callback,
      interventionType: interventionType.funfact,
      endOfPhrase: endOfPhrase
    }),
  };
  const data = formatResults(modal, message);
  callback(data);
}

/*=======LIP SYNC=========
This intervention has 3 parts:
1. Show the modal and speak the introduction. The callback for the introduction kicks off -
2. Play the lip-sync video. This is simply a modal with an HTML5 video element. The video onend will kick off -
3. The "let's keep reading"
*/

function handleLipSync(speech, inWord,callback,endOfPhrase=false,metadata,type){
  let videoToPlay = (type === interventionType.lipsync) ? metadata.VIDEO_URL : metadata.PHONEME_VIDEO_URL; //TODO: Change this when we add the 3rd kind of lipsyc
  const currentWord = inWord;
  let speakLipSync = (onEnd) => {
    let forceEnqueue = false;
    if(endOfPhrase){
      speakInterventionLeadIn(speech, interventionType.lipsync,inWord);
      forceEnqueue = true;
    }
    if(getUserData().bilingualMode){
      speech.speak({textToSpeak: COPY_STRINGS.intervention_strings.watch_lips}, undefined, undefined, forceEnqueue);
      speech.speak({textToSpeak: currentWord, skipTranslation: true, onEnd: getUserData().sessionData.useIpadFallbacks ? null : onEnd}, undefined, undefined, true);
      if(getUserData().sessionData.useIpadFallbacks){
        speech.speak({textToSpeak: COPY_STRINGS.intervention_strings.tap_play, onEnd: onEnd})
      }
    } else {
      let textToSpeak = COPY_STRINGS.intervention_strings.watch_lips + ": " + `"${currentWord}".`;
      if(getUserData().sessionData.useIpadFallbacks){
        textToSpeak += " " + COPY_STRINGS.intervention_strings.tap_play;
      }
      speech.speak({textToSpeak: textToSpeak, onEnd: onEnd});
    }
  }
  const message ={
    speakFunction: speakLipSync,
    callback: playVideo.bind(null,currentWord,callback,endOfPhrase,metadata,speech,videoToPlay),
  };
  const instructions = (<div>{COPY_STRINGS.intervention_strings.watch_how_to_say}:</div>);
  const image = {
    icon: metadata.IMG_URL ? metadata.IMG_URL : lip_sync_icon,
    useWordIcon: metadata.IMG_URL ? false : true,
  };

  //listening status is hidden on the intervention modal because it's displayed by LipSync
  const modal = getWordInterventionModal(currentWord, instructions, image, null, false);
  const data = formatResults(modal, message);
  callback(data);
}

let playCount = 0;

function onVideoDonePlaying(inWord,callback,endOfPhrase,speech){
  playCount++;
  if(playCount > 1) return;
    getWordResponse({
      speech: speech,
      targetWord: inWord,
      callback: callback,
      interventionType: interventionType.lipsync,
      closeText: COPY_STRINGS.intervention_strings.now_you_say_word,
      endOfPhrase: endOfPhrase,
    });
}

function playVideo(inWord,callback,endOfPhrase,metadata, speech, videoURL){
  let onDone = onVideoDonePlaying.bind(null,inWord,callback,endOfPhrase, speech);

  playCount = 0;
  let video = (
    <LipSync
      onDone={onDone}
      videoURL={videoURL}
      speech={speech}
      word={inWord}
    />
  );
  const data = formatResults(video,null)
  callback(data);
}

function handleRiddle(speech, word, wordMetadata, handleMessage, endOfPhrase, callback){
  callback(
    {modal:
      <Riddle
        speech={speech}
        word={word}
        wordMetadata={wordMetadata}
        endOfPhrase={endOfPhrase}
        handleMessage={handleMessage}
      />
    }
  );
}

function handleMorpheme(speech, word, wordMetadata, handleMessage, endOfPhrase, callback){
  callback(
    {modal:
        <Morpheme
          speech={speech}
          word={word}
          wordMetadata={wordMetadata}
          endOfPhrase={endOfPhrase}
          handleMessage={handleMessage}
        />
    }
  );
}

function handleCognate(speech, word, wordMetadata, handleMessage, endOfPhrase, callback){
  callback(
    {modal:
        <Cognate
          speech={speech}
          word={word}
          wordMetadata={wordMetadata}
          endOfPhrase={endOfPhrase}
          handleMessage={handleMessage}
        />
    }
  );
}

async function handleVocabularyWithPicture(speech, word, wordMetadata, handleMessage, endOfPhrase, callback){
  callback(
    {modal:
        <VocabularyWithPicture
          speech={speech}
          word={word}
          wordMetadata={wordMetadata}
          endOfPhrase={endOfPhrase}
          handleMessage={handleMessage}
        />
    }
  );
}

function handlePrediction(speech, word, wordMetadata, phraseMetadata, handleMessage, endOfPhrase, callback){
  if(!(phraseMetadata && phraseMetadata.predictionQuestions && phraseMetadata.predictionQuestions.length)){
    moveOnWithoutSpeaking(callback, endOfPhrase);
    return;
  }

  const metadata = {
    ...wordMetadata,
    ...phraseMetadata.predictionQuestions[0]
  };
  callback(
    {modal:
        <PredictionQuestion
          speech={speech}
          word={word}
          metadata={metadata}
          endOfPhrase={endOfPhrase}
          handleMessage={handleMessage}
        />
    }
  );
}

function handleLetterFlies(speech, word, wordMetadata, handleMessage, endOfPhrase, callback, interventionVersion){
  callback(
    {modal:
      <LetterFlies
        version={interventionVersion}
        speech={speech}
        word={word}
        wordMetadata={wordMetadata}
        endOfPhrase={endOfPhrase}
        handleMessage={handleMessage}
        ftue={checkFtue([interventionType.letterFlies])}
      />
    }
  );
}

function handleSayASound(speech, word, wordMetadata, handleMessage, endOfPhrase, callback, interventionVersion){
  callback(
    {modal:
      <SayASound
        StudentVideo={StudentVideo}
        version={interventionVersion}
        speech={speech}
        word={word}
        wordMetadata={wordMetadata}
        endOfPhrase={endOfPhrase}
        handleMessage={handleMessage}
      />
    }
  );
}

async function handleSoundSeeker(speech, word, wordMetadata, handleMessage, endOfPhrase, callback, interventionVersion, mostRecentScores){
  callback(
    {modal:
      <SoundSeeker
        version={interventionVersion}
        speech={speech}
        word={word}
        wordMetadata={wordMetadata}
        endOfPhrase={endOfPhrase}
        handleMessage={handleMessage}
        wcpm={mostRecentScores.wcpm}
      />
    }
  );
}

function handleName(speech, word, wordMetadata, handleMessage, endOfPhrase, callback, interventionVersion){
  callback(
    {modal:
      <Name
        StudentVideo={StudentVideo}
        version={interventionVersion}
        speech={speech}
        word={word}
        wordMetadata={wordMetadata}
        endOfPhrase={endOfPhrase}
        handleMessage={handleMessage}
      />
    }
  );
}

function handleSoundOut(speech, word, wordMetadata, handleMessage, endOfPhrase, callback, interventionVersion){
  callback(
    {modal:
      <SoundOut
        version={interventionVersion}
        speech={speech}
        word={word}
        wordMetadata={wordMetadata}
        endOfPhrase={endOfPhrase}
        handleMessage={handleMessage}
      />
    }
  );
}

function handleElkoninBox(speech, word, wordMetadata, handleMessage, endOfPhrase, callback, interventionVersion){
  callback(
    {modal:
      <ElkoninBox
        version={interventionVersion}
        speech={speech}
        word={word}
        wordMetadata={wordMetadata}
        endOfPhrase={endOfPhrase}
        handleMessage={handleMessage}
        startFakeListen={startFakeListen}
        stopFakeListen={stopFakeListen}
        ftue={checkFtue([interventionType.elkoninBox0, interventionType.elkoninBox1, interventionType.elkoninBox2, interventionType.elkoninBox3, interventionType.elkoninBox4])}
      />
    }
  );
}

function handleUpAndDown(speech, word, wordMetadata, handleMessage, endOfPhrase, callback, interventionVersion){
  callback(
    {modal:
      <UpAndDown
        version={interventionVersion}
        speech={speech}
        word={word}
        wordMetadata={wordMetadata}
        endOfPhrase={endOfPhrase}
        handleMessage={handleMessage}
        ftue={checkFtue([interventionType.upAndDown1, interventionType.upAndDown2, interventionType.upAndDown3])}
      />
    }
  );
}

async function handleChangeOnePart(speech, word, wordMetadata, handleMessage, endOfPhrase, callback, interventionVersion, mostRecentScores){
  const {subData, position} = await getSubMetadata(wordMetadata, mostRecentScores);

  let SUBS = []
  const originalPhonemeCount = wordMetadata?.NPHON;
  for (const subDatum of subData) {
    const {WORD, PHON, NPHON, log_ngram_counts} = subDatum;
    if (!PHON || log_ngram_counts < 15) continue;
    // Only apply phoneme-count filter when both counts are known; if either is
    // missing (e.g. word lacks NPHON data), allow the candidate through as a fallback.
    if (originalPhonemeCount != null && NPHON != null && NPHON !== originalPhonemeCount) continue;
    SUBS.push({word: WORD, phon: PHON})
    if (SUBS.length === 2) break;
  }

  // exit if did not find two SUBS
  if (SUBS.length !== 2) SUBS = null;

  wordMetadata.SUB_POSITION = position;
  wordMetadata.SUBS = SUBS;

  callback(
    {modal:
      <ChangeOnePart
        version={interventionVersion}
        speech={speech}
        word={word}
        wordMetadata={wordMetadata}
        endOfPhrase={endOfPhrase}
        handleMessage={handleMessage}
        ftue={checkFtue([interventionType.changeOnePart1])}
      />
    }
  );
}

async function handleGiveAndTake(speech, word, wordMetadata, handleMessage, endOfPhrase, callback, interventionVersion, mostRecentScores){
  const {subData, position} = await getSubMetadata(wordMetadata, mostRecentScores);

  let SUB, SUB_PHON;
  for (const subDatum of subData) {
    const {WORD, PHON} = subDatum;
    if (PHON) {
      SUB = WORD;
      SUB_PHON = PHON;
      break;
    }
  }

  wordMetadata.SUB_POSITION = position;
  wordMetadata.SUB = SUB;
  wordMetadata.SUB_PHON = SUB_PHON;

  callback(
    {modal:
      <GiveAndTake
        version={interventionVersion}
        speech={speech}
        word={word}
        wordMetadata={wordMetadata}
        endOfPhrase={endOfPhrase}
        handleMessage={handleMessage}
        ftue={checkFtue([interventionType.giveAndTake1])}
      />
    }
  );
}

async function handleRhyming(speech, word, wordMetadata, handleMessage, endOfPhrase, callback, interventionVersion){
  wordMetadata.RHYME = wordMetadata.RHYME.trim(); // Fixes bug where RHYME is "word " instead of "word"
  const {RHYME} = wordMetadata;
  const list = await getWordMetadataList([RHYME]);
  const rhymeMetadata = list[0];
  const {GRAPHEMIC_BREAKDOWN, PHON} = rhymeMetadata;
  wordMetadata.RHYME_GRAPHEMIC_BREAKDOWN = GRAPHEMIC_BREAKDOWN;
  wordMetadata.RHYME_PHON = PHON;
  callback(
    {modal:
      <Rhyming
        version={interventionVersion}
        speech={speech}
        word={word}
        wordMetadata={wordMetadata}
        endOfPhrase={endOfPhrase}
        handleMessage={handleMessage}
        ftue={checkFtue([interventionType.rhyming1])}
      />
    }
  );
}

function handleRhymingQuiz(speech, word, wordMetadata, handleMessage, endOfPhrase, callback, interventionVersion){
  callback(
    {modal:
      <RhymingQuiz
        version={interventionVersion}
        speech={speech}
        word={word}
        wordMetadata={wordMetadata}
        endOfPhrase={endOfPhrase}
        handleMessage={handleMessage}
        ftue={checkFtue([interventionType.rhymingQuiz1])}
      />
    }
  );
}

function handleSayOneSound(speech, word, wordMetadata, handleMessage, endOfPhrase, callback, interventionVersion){
  callback(
    {modal:
      <SayOneSound
        version={interventionVersion}
        speech={speech}
        word={word}
        wordMetadata={wordMetadata}
        endOfPhrase={endOfPhrase}
        handleMessage={handleMessage}
        ftue={checkFtue([interventionType.sayOneSound1])}
      />
    }
  );
}

function handleWordInvestigator(speech, word, wordMetadata, handleMessage, endOfPhrase, callback, interventionVersion){
  callback(
    {modal:
      <WordInvestigator
        version={interventionVersion}
        speech={speech}
        word={word}
        wordMetadata={wordMetadata}
        endOfPhrase={endOfPhrase}
        handleMessage={handleMessage}
        ftue={checkFtue([interventionType.wordInvestigator1,interventionType.wordInvestigator2])}
      />
    }
  );
}

function handleWordScramble(speech, word, wordMetadata, handleMessage, endOfPhrase, callback, interventionVersion){
  callback(
    {modal:
      <WordScramble
        version={interventionVersion}
        speech={speech}
        word={word}
        wordMetadata={wordMetadata}
        endOfPhrase={endOfPhrase}
        handleMessage={handleMessage}
        ftue={checkFtue([interventionType.wordScramble1])}
      />
    }
  );
}

function handleWordDisplay(speech, word, wordMetadata, handleMessage, endOfPhrase, callback, interventionVersion){
  callback(
    {modal:
      <WordDisplay
        StudentVideo={StudentVideo}
        version={interventionVersion}
        speech={speech}
        word={word}
        wordMetadata={wordMetadata}
        endOfPhrase={endOfPhrase}
        handleMessage={handleMessage}
      />
    }
  );
}

function getWordResponse(args){
  const {
    callback,
    endOfPhrase,
    closeText=COPY_STRINGS.intervention_strings.now_you_try_word,
    onListenDone=moveOnWithoutSpeaking.bind(null, callback, endOfPhrase),
  } = args;

  const message = {
    listen: listen.bind(null, {
      ...args,
      callback: onListenDone,
      closeText: closeText,
    })
  };

  const data = formatResults(null,message);
  callback(data);
}

export function moveOnWithoutSpeaking(callback, endOfPhrase){
  let message = {continueWithoutSpeaking: true, endOfPhrase: endOfPhrase};
  const data = formatResults(null,message);
  callback(data);
}

function checkFtue(types) {
  for (const type of interventionHistory) {
    if (types.includes(type)) return false;
  }
  return true;
}